import { getStore } from "../api/storePresentation";
import { getSocialLinks } from "../../i18n/utilities";

import {
  DEFAULT,
  FEMALE,
  MALE,
  SECURE
} from "../template/state/modules/layout/constants";

const TYPES = [DEFAULT, FEMALE, MALE, SECURE];

export { DEFAULT, FEMALE, MALE, SECURE };

const addTrailingSlash = str => `${str}/`;

export const storeUrlsForAllFloors = async (
  countryCode,
  platform,
  keyStoreDataversion
) => {
  const { features } = await getStore().getVersionManifest();
  const mdotFlag = features && features["stc-mdot-disabled"];
  const mdotDisabled = mdotFlag || keyStoreDataversion === "rja8w2a-13";

  const storeUrls = {};
  for (const i in TYPES) {
    const type = TYPES[i];
    storeUrls[type] = addTrailingSlash(
      await getStore().getStoreUrlByCountryCode({
        countryCode,
        type,
        keyStoreDataversion,
        includeProtocol: true,
        isMobile: platform === "mobile" && mdotDisabled === false
      })
    );
  }
  return storeUrls;
};

export const storeLinksForAllFloors = storeCode =>
  TYPES.reduce(
    (links, type) => ({
      ...links,
      [type]: getSocialLinks({ storeCode, floor: type })
    }),
    {}
  );
